import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const crmPipelineTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "crm.pipeline-trend",
  name: "Pipeline growth",
  description: "Pipeline growth across the selected period.",
  apps: [
    "home",
    "crm",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "crm.prospects",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "expected_value",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Pipeline value",
        query: {
          version: 1,
          source: "crm.prospects",
          ...period(30),
          select: [
            {
              type: "field",
              field: "created_at",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "expected_value",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "created_at",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#ae3ec9",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Pipeline growth",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "$128,400",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
